"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cassano-valcuvia": {
    "0493b7bf": [{
      "hkey": "a625aec2",
      "slug": "cassano-valcuvia",
      "name": "Cassano Valcuvia",
      "primary": true,
      "skipSearch": false
    }],
    "ca-di-rocco": [{
      "hkey": "a625aec2",
      "slug": "cassano-valcuvia",
      "name": "Cassano Valcuvia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "307a6a37": [{
      "hkey": "a625aec2",
      "slug": "cassano-valcuvia",
      "name": "Cassano Valcuvia",
      "primary": true,
      "skipSearch": false
    }],
    "crotto": [{
      "hkey": "a625aec2",
      "slug": "cassano-valcuvia",
      "name": "Cassano Valcuvia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0c3540a9": [{
      "hkey": "a625aec2",
      "slug": "cassano-valcuvia",
      "name": "Cassano Valcuvia",
      "primary": true,
      "skipSearch": false
    }],
    "lische": [{
      "hkey": "a625aec2",
      "slug": "cassano-valcuvia",
      "name": "Cassano Valcuvia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0ad9c876": [{
      "hkey": "a625aec2",
      "slug": "cassano-valcuvia",
      "name": "Cassano Valcuvia",
      "primary": true,
      "skipSearch": false
    }],
    "molino-andreoni": [{
      "hkey": "a625aec2",
      "slug": "cassano-valcuvia",
      "name": "Cassano Valcuvia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9ec7548a": [{
      "hkey": "a625aec2",
      "slug": "cassano-valcuvia",
      "name": "Cassano Valcuvia",
      "primary": true,
      "skipSearch": false
    }],
    "monte-san-martino": [{
      "hkey": "a625aec2",
      "slug": "cassano-valcuvia",
      "name": "Cassano Valcuvia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ae58406e": [{
      "hkey": "a625aec2",
      "slug": "cassano-valcuvia",
      "name": "Cassano Valcuvia",
      "primary": true,
      "skipSearch": false
    }],
    "san-giuseppe": [{
      "hkey": "a625aec2",
      "slug": "cassano-valcuvia",
      "name": "Cassano Valcuvia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "645b4f63": [{
      "hkey": "a625aec2",
      "slug": "cassano-valcuvia",
      "name": "Cassano Valcuvia",
      "primary": true,
      "skipSearch": false
    }],
    "sasso-cadrega": [{
      "hkey": "a625aec2",
      "slug": "cassano-valcuvia",
      "name": "Cassano Valcuvia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c2b404f": [{
      "hkey": "a625aec2",
      "slug": "cassano-valcuvia",
      "name": "Cassano Valcuvia",
      "primary": true,
      "skipSearch": false
    }],
    "villa-san-giuseppe": [{
      "hkey": "a625aec2",
      "slug": "cassano-valcuvia",
      "name": "Cassano Valcuvia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;